import { HomeType, ImageBackgroundSection } from "@/types";
import { RichText } from "@/components/StrapiComponents/RichText";
import StrapiImage from "../StrapiComponents/StrapiImage";

export const ImageBackgroundSectionComponent = ({ content, index, homeContent, renderQR }: { content: ImageBackgroundSection; index: number; homeContent: HomeType | null; renderQR: boolean }) => {
	return (
		<section className={`section-wrapper section-text-image orientation-${content.orientation}`}>
			<div className="max-wrapper-content">
				{content.orientation === "Left" && (
					<>
						<div className="flex">
							<div className={`content-wrapper width-8 ${content.align === "Center" ? "flex flex-column flex-v-center" : ""}`}>
								<h1 className="translate">
									<span>{content.title.replace(/&shy;/g, "\n")}</span>
								</h1>
								<RichText content={content.content} />
							</div>
							<div className="content-wrapper  width-4 flex flex-column flex-end">
								{content.image && (
									<>
										{index === 1 && homeContent && homeContent.qrImage && renderQR && (
											<div className="qr-position-absolute">
												<StrapiImage media={homeContent.qrImage} loadingType="lazy" format="large" />
											</div>
										)}
										<StrapiImage media={content.image} loadingType="lazy" format="large" />
									</>
								)}
							</div>
						</div>
					</>
				)}

				{content.orientation === "Right" && (
					<>
						<div className="flex">
							<div className="content-wrapper width-4 flex flex-column flex-end">
								{content.image && (
									<>
										{index === 1 && homeContent && homeContent.qrImage && renderQR && (
											<div className="qr-position-absolute">
												<StrapiImage media={homeContent.qrImage} loadingType="lazy" format="large" />
											</div>
										)}
										<StrapiImage media={content.image} loadingType="lazy" format="large" />
									</>
								)}
							</div>
							<div className={`content-wrapper width-8 ${content.align === "Center" ? "flex flex-column flex-v-center" : ""}`}>
								<h1 className="translate">
									<span>{content.title.replace(/&shy;/g, "\n")}</span>
								</h1>
								<RichText content={content.content} />
							</div>
						</div>
					</>
				)}
			</div>
		</section>
	);
};
